<script>
export default {
  name: 'NullPresenter',
};
</script>
<template>
  <em>{{ __('None') }}</em>
</template>
